/* eslint-disable no-unused-vars */

export enum ListSearchType {
  TRAFFIC_ARCHIVE = 'traffic_archive',
  PARTNER = 'partner',
  SEARCH_PARTNER = 'search_partner',
  PROJECT = 'project',
  SEARCH_PROJECT = 'search_project',
  SELECT_SEARCH_PROJECT = 'select_search_project',
  TASK = 'task',
  SEARCH_TASK = 'search_task',
  SELECT_SEARCH_TASK = 'select_search_task',
  PROJECT_TASK_LIST = 'project_task_list',
  USER_COMMON_TASK = 'user_common_task',
  GROUPED_TIMESHEET_REPORT = 'grouped_timesheet_report',
  USER = 'user',
  USER_TIMESHEET_REPORT = 'user_timesheet_report',
  TIMESHEET_REPORT = 'timesheet_report',
  OBJECT_TIMESHEET_REPORT = 'object_timesheet_report',
  SELECT_SEARCH_USER = 'select_search_user',
  SELECT_SEARCH_USER_WITH_HOLIDAY = 'select_search_user_with_holiday',
  USER_TIMER_HISTORY = 'user_timer_history',
  USER_REPORT = 'user_report',
  CLIENT_REPORT = 'client_report',
  USER_DAILY_REPORT = 'user_daily_report',
  MY_TASKS = 'my_tasks',
  TRAFFIC = 'traffic',
  DAILY_TRAFFIC = 'daily_traffic',
  ARCHIVE_TRAFFIC = 'archive_traffic',
  MY_TRAFFIC = 'my_traffic',
  MY_JOBS = 'my_jobs',
  ROLE = 'role',
  PERMISSION = 'permission',
  HOLIDAY = 'holiday',
  USER_OWN_HOLIDAYS = 'user_own_holidays',
  HOLIDAY_DAY_CHANGES = 'holiday_day_changes',
  HOLIDAY_APPROVE_REQUEST = 'holiday_approve_request',
  PROJECT_INCOME = 'project_income',
  PROJECT_CASH_EXPENSE = 'project_cash_expense',
  PROJECT_SUBCONTRACTOR_EXPENSE = 'project_subcontractor_expense',
  OPTIONS_SEARCH_PROJECT_EXPENSE = 'options_search_project_expense',
  OPTIONS_SEARCH_PROJECT_INCOME = 'options_search_project_income',
  SEARCH_PROJECT_EXPENSE = 'search_project_expense',
  CHANGE_PROJECT_TASK_FORM = 'change_project_task_form',
  PROJECT_EXPENSE_WITH_INVOICES = 'project_expense_with_invoices',
  INCOMING_INVOICE = 'incoming_invoice',
  OUTGOING_INVOICE = 'outgoing_invoice',
  CASH_INVOICE = 'cash_invoice',
  RANKED_IDEAS = 'ranked_ideas',
  IDEAS = 'ideas',
  DASHBOARD_IDEA = 'dashboard_idea',
  MY_IDEA = 'my_idea',
  PROJECT_EXPENSE_REPORT = 'project_expense_report',
  FINANCE_REPORT = 'finance_report',
  FINANCE_FULL_REPORT = 'finance_full_report',
  FILE = 'file',
  CASH_INVOICE_FORM = 'cash_invoice_form',
  IDEA_FORM = 'idea_form',
  MIXED_VOUCHER_FORM = 'mixed_voucher_form',
  INCOMING_INVOICE_FORM = 'incoming_invoice_form',
  PROJECT_SEARCH = 'project_search',
  CLIENT_FORM = 'client_form',
  SUPPLIER_FORM = 'supplier_form',
  OUTGOING_INVOICE_FORM = 'outgoing_invoice_form',
  MIXED_VOUCHERS = 'mixed_voucher',
  USER_FORM = 'user_form',
  TIMESHEET_FORM = 'timesheet_form',
  MOVE_TIMESHEET_FORM = 'move_timesheet_form',
  JOB_TITLES = 'job_titles',
  JOB_TITLE_FORM = 'job_title_form',
  JOB_TITLES_SEARCH = 'job_titles_search',
  JOB_TITLES_SELECT = 'job_titles_select',
  JOB_TITLES_SELECT_FOR_USER = 'job_titles_select_for_user',

  MENTOR_TITLES = 'mentor_titles',
  MENTOR_TITLE_FORM = 'mentor_title_form',
  MENTOR_TITLES_SEARCH = 'mentor_titles_search',
  MENTOR_TITLES_SELECT = 'mentor_titles_select',
  MENTOR_TITLES_SELECT_FOR_USER = 'mentor_titles_select_for_user',

  SEARCH_JOB_APPLICANT = 'search_job_applicant',
  JOB_APPLICANT_FORM = 'job_applicant_from',
  JOB_APPLICANTS = 'job_applicants',

  SEARCH_MENTOR_APPLICANT = 'search_mentor_applicant',
  MENTOR_APPLICANT_FORM = 'mentor_applicant_from',
  MENTOR_APPLICANTS = 'mentor_applicants',

  USER_PROFILE_HOLIDAY = 'user_profile_holiday',
  USER_TIMESHEET_TABLE = 'user_timesheet_table',
  TIMESHEET_TABLE = 'timesheet_table',
  USER_NOTIFICATION_SETTINGS = 'user_notification_settings',
  USER_PROJECT_NOTIFICATION_SETTINGS = 'user_project_notification_settings',
  INCOME_GOAL_POSSIBLE_FILTERS = 'income_goal_possible_filters',
  INCOME_GOAL = 'income_goal',
  INCOME_GOAL_SEARCH = 'income_goal_search',
  INCOME_GOAL_FORM = 'income_goal_form',
  INCOME_GOAL_FILTER_SEARCH = 'income_goal_filter_search',
  WORKING_TIMES = 'working_times',
  WORKING_TIMES_FORM = 'working_times_form',
  CASH_FLOW_PROJECT_BILLED = 'cash_flow_projects_billed',
  CASH_FLOW_PROJECT_EXPECTED = 'cash_flow_projects_expected',
  CASH_FLOW_GENERAL_EXPENSES = 'cash_flow_general_expenses',
  CASH_FLOW_SALARY_CONTRIBUTION_ELSE = 'cash_flow_salary_contribution_else',
  CASH_FLOW_VAT = 'cash_flow_vat',
  CASH_FLOW_VAT_DETAILS = 'cash_flow_vat_details',
  CASH_FLOW_DETAILED = 'cash_flow_detailed',
  CASH_FLOW_MONTHLY_SUMMARY = 'cash_flow_monthly_summary',
  CASH_FLOW_FORM = 'cash_flow_form',
  DOCUMENTS_SEARCH = 'documents_search',
  DOCUMENTS = 'documents',
  DOCUMENTS_FORM = 'documents_form',
  USER_DOCUMENTS_FORM = 'user_documents_form',
  COMMENT = 'comment',
  TASK_EDIT_FORM = 'task_edit_form',
  ASSET_SEARCH = 'asset_search',
  ASSET = 'asset',
  ASSET_USER_PROFILE = 'asset_user_profile',
  ASSET_FORM = 'asset_form',
  ASSET_USER_FORM = 'asset_user_form',
  USER_BIRTHDAY = 'user_birthday',
  BIRTHDAY_LIST = 'birthday_list',
}

export enum ObjectTransform {
  CARD = 'card',
  BASIC = 'basic',
  EXTENDED = 'extended',
  SEARCH = 'search',
  TASK_TREE = 'task_tree',
  INVOICE = 'invoice',
  CLIENT_GROUP = 'client_group',
  HOLIDAY_REQUEST_GROUP = 'holiday_request_group',
  TIMESHEETABLE_GROUP = 'timesheetable_group',
  USER_GROUP = 'user_group',
  JOB_TITLE_GROUP = 'job_title_group',
  PROJECT_GROUP = 'project_group',
  TASK_GROUP = 'task_group',
  DATE_GROUP = 'date_group',
  BIRTHDAY = 'birthday',
}
